import React from "react";
import landingImg from "../../../assets/landing_page_image_1.png";

const PageNavHeader = ({ children, afterContent, mobileAlign = "center" }) => (
  <section className="relative w-full overflow-hidden" style={{ backgroundColor: "#020013" }}>
    <div
      className="absolute top-0 left-0 right-0 pointer-events-none h-[220px] md:h-[373px]"
      style={{ backgroundImage: `url(${landingImg})`, backgroundSize: "cover", backgroundPosition: "center top", zIndex: 0 }}
    />
    <div className={`relative z-10 w-full px-4 md:px-16 lg:px-20 pt-40 md:pt-44 pb-10 md:pb-14 ${mobileAlign === "left" ? "text-left md:text-center" : "text-center"}`}>
      {children}
    </div>
    {afterContent}
  </section>
);

export default PageNavHeader;
